/* eslint-disable no-param-reassign */
// open external links in new tab

function isFileLink(url) {
  const fileExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'jpg', 'jpeg', 'png', 'gif'];

  const urlParts = url.split('.');
  const extension = urlParts[urlParts.length - 1].toLowerCase();

  return fileExtensions.includes(extension);
}

function openExternalLink() {
  document.querySelectorAll('.body-copy a[href]:not(.button):not(.no-icon)').forEach((item) => {
    if (window.location.hostname !== new URL(item.href).hostname && !isFileLink(item.href)) {
      item.target = '_blank';
      item.rel = 'noreferrer nofollow noopener';
      item.classList.add('is-external-link');
      item.insertAdjacentHTML(
        'beforeend',
        `<span class="external-icon" focusable="false" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_86_10043)">
        <path d="M10 6V8H5V19H16V14H18V20C18 20.2652 17.8946 20.5196 17.7071 20.7071C17.5196 20.8946 17.2652 21 17 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V7C3 6.73478 3.10536 6.48043 3.29289 6.29289C3.48043 6.10536 3.73478 6 4 6H10ZM21 3V11H19V6.413L11.207 14.207L9.793 12.793L17.585 5H13V3H21Z" fill="#24628F"/>
        </g>
        <defs>
        <clipPath id="clip0_86_10043">
        <rect width="24" height="24" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        </span> `,
      );
    }
  });
}

window.addEventListener('load', () => {
  openExternalLink();
});
